import React from "react";
import { Request } from "./components/Request";
export const App: React.FC = () => {
  return <Request></Request>;
};
